import React from "react"
import DynamicActionActivity from "./DynamicActionActivity"

export default function TypeDynamicNestedMF(props) {
  const { field } = props
  switch (field.field_name) {
    case "action_activity":
      return <DynamicActionActivity {...props} />
    default:
      return null
  }
}
